import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const SubtitleStyled = styled.h3`
  font-weight: 400;
  font-size: 1.8rem;
  line-height: 2.8rem;
  letter-spacing: 0.028rem;
  text-align: center;
  color: ${colors.neutral[900]};
  position: relative;
  overflow: hidden;
  margin: 2rem 0;
`;

export const SubtitleTextStyled = styled.span`
  display: inline-block;
  vertical-align: baseline;
  position: relative;
  padding: 0 1rem;

  &::before,
  &::after {
    content: '';
    display: block;
    width: 40rem;
    position: absolute;
    top: 50%;
    border-top: 0.1rem solid ${colors.neutral[300]};
  }

  &::before {
    right: 100%;
  }

  &::after {
    left: 100%;
  }

  @media (width <= 450px) {
    padding: 0;

    &::before,
    &::after {
      display: none;
    }
  }
`;
